import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import { AgGrid } from '../AgGrid';
import { getAgentsByClientId, saveMasterAgentByAgentId } from '../../services';
import { DynamicFormModal } from '../DynamicForm';
import * as v from '../../helpers/validation';
import styles from './AgentMasterList.styles';
import AgentCreateForm from '../FileImportForm/AgentCreateForm';

const AgentMasterList = ({ classes, clientId }) => {
  const [agentMasterListData, setAgentMasterListData] = React.useState();
  const [modalVisible, setModalVisible] = React.useState(false);
  const [modalData, setModalData] = React.useState();
  const [agentCreateForm, setAgentCreateForm] = React.useState(false);
  const [headers, setHeaders] = React.useState();

  const columnDefs = [
    {
      field: 'agentCode',
      headerName: 'Agent Code',
    },
    {
      field: 'agentName',
      headerName: 'Agent Name',
    },
    {
      field: 'agentPhone',
      headerName: 'Agent Phone',
    },
    {
      field: 'agentEmail',
      headerName: 'Agent Email',
    },
    {
      field: 'recordMode',
      headerName: 'RecordMode',
    },
  ];

  const agentMasterInputs = [
    {
      inputType: 'text',
      field: 'agentCode',
      label: 'Agent Code',
      validate: [v.required()],
    },
    {
      inputType: 'text',
      field: 'agentName',
      label: 'Agent Name',
    },
    {
      inputType: 'text',
      field: 'agentPhone',
      label: 'Agent Phone',
    },
    {
      inputType: 'text',
      field: 'agentEmail',
      label: 'Agent Email',
    },
    {
      inputType: 'select',
      field: 'recordMode',
      label: 'Record Mode',
      options: [
        { label: 'Off', value: false },
        { label: 'On', value: true },
      ],
    },
  ];

  /* API */

  const onSave = async data => {
    setModalData();
    console.log(data);
    try {
      const success = await saveMasterAgentByAgentId(data, data?.id);
      setModalData(data);
      setModalVisible(false);
    } catch (ex) {
      console.log(ex);
    }
  };

  /* FUNCTIONs */
  const onRowClicked = ev => {
    setModalVisible(!modalVisible);
    setModalData(ev.data);
  };

  const gridOptions = {
    onRowClicked: onRowClicked,
    singleClickEdit: true,
    enableGroupEdit: true,
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setModalData({});
  };

  React.useEffect(() => {
    const getAgentsAsync = async () => {
      const results = await getAgentsByClientId(clientId);
      setAgentMasterListData(results);
    };
    getAgentsAsync();

    setModalData();
  }, [modalData, modalVisible]);

  return (
    <>
      <AgGrid
        gridData={agentMasterListData}
        columnDefs={columnDefs}
        editOnClick={false}
        showCreateButton={true}
        redirectOnClick={false}
        mode={'EDIT'}
        gridOptions={gridOptions}
        handleCreateClick={() => setAgentCreateForm(!agentCreateForm)}
      />
      <DynamicFormModal
        modalVisible={modalVisible}
        hideModal={handleCloseModal}
        inputs={agentMasterInputs}
        mode={'EDIT'}
        onSave={onSave}
        modalLabel={'Edit Agent'}
        data={modalData}
      />
      <AgentCreateForm setOpen={setAgentCreateForm} open={agentCreateForm} client={{ id: clientId }} />
    </>
  );
};

AgentMasterList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(AgentMasterList));
